import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardPictures = (
  property: IPropertyDetailsResponse
): string[] => {
  return property.pictures.map(picture => picture.pictures);
};
